import * as types from "../types/site.config.types";
import {getBulkListingService, patchEdit} from '../../services/siteConfig.service';
import { validationErrors } from "../../utils/Helpers";


export const listAction = (param, data) => {
  return async (dispatch, getState)  => {
    try {
      dispatch({
        type: types.SET_SITE_CONFIG_LOADING,
        payload: true,
      });
      await getBulkListingService(getState().authReducer.token, getState().authReducer.user.id, param, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_SITE_CONFIG_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_SITE_CONFIG_PAGINATION,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({
        type: types.SET_SITE_CONFIG_LOADING,
        payload: false,
      });
    }
  };
}

export const filterAction = (data) => {  
  return async (dispatch) => {
    try {
      dispatch({
        type: types.SET_SITE_CONFIG_FILTER,
        payload: data,
      });
    } catch {}
  }
}

export const patchAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_SITE_CONFIG_LOADING, payload: true});
      return await patchEdit(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_SITE_CONFIG_LOADING, payload: false});
    }
  };
};